var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mockup",class:{
    'mockup--phone': _vm.device === 'phone',
    'mockup--pc': _vm.device === 'pc',
  }},[_c('div',{staticClass:"mockup__image"},[_c('ImageComponent',{attrs:{"head_img":_vm.data,"title":"Макет","quality":"50"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }